import { gql } from '@apollo/client';

export const FETCH_WRF_MODEL_CONFIGURATIONS = gql`
    query fetchWrfModelConfigurations {
        facility {
            models {
                wrfModelConfigurations {
                    filename
                }
            }
        }
    }
`;
